export interface ClientProfileClient {
  name: string | null;
  phone: string | null;
  telegramUsername: string | null;
  avatarUrl: string | null;
}

export interface ClientProfileBusiness {
  name: string | null;
  subtitle: string | null;
  address: string | null;
  workingHours: string | null;
  phone: string | null;
  telegramContact: string | null;
  mapUrl: string | null;
}

export interface ClientProfilePolicies {
  cancellation: string | null;
  payment: string | null;
  lateArrival: string | null;
}

export interface ClientProfile {
  client: ClientProfileClient;
  business: ClientProfileBusiness;
  policies: ClientProfilePolicies;
}

export function hasAnyValue(obj: Record<string, string | null>): boolean {
  return Object.values(obj).some((v) => v !== null);
}
